import styled from 'styled-components'

const Container = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
    padding: 0px 10px;

  > span {
    width: 100%;
    margin: 0 14px;
  }

  @media(min-width: ${props => props.theme.mediaQuery.smallpc}) { 
    flex-wrap: nowrap;
    padding: 0;

    > span {
      max-width: 196px;
      margin-right: 128px;
    }
  }
`

export { Container }
